module.exports = __webpack_public_path__ + "assets/img/00158.55cd7fbc.png";